import { InfoDeviceService, LocalStorageService } from '@project/services';
import { ApiService } from '@core/http';

import { WEBSOCKET_AVAILABLE_PROVIDERS, WebsocketAvailableProvider, WebSocketClient } from '../definitions';
import { NativeWebSocketProvider, SocketIoWebSocketProvider } from '../providers';
import { ChatUploadHelperService } from '../services';

export class WebsocketClientFactory {
  constructor(
    private localstorageService: LocalStorageService,
    private apiService: ApiService,
    private chatUploaderHelperService: ChatUploadHelperService,
    private infoDeviceService: InfoDeviceService,
  ) {}

  public getProvider(provider: WebsocketAvailableProvider): WebSocketClient {
    switch (provider.toUpperCase()) {
      case WEBSOCKET_AVAILABLE_PROVIDERS.NATIVE:
        return new NativeWebSocketProvider(this.apiService);
      case WEBSOCKET_AVAILABLE_PROVIDERS.SOCKET_IO:
      default:
        return new SocketIoWebSocketProvider(
          this.localstorageService,
          this.apiService,
          this.chatUploaderHelperService,
          this.infoDeviceService,
        );
    }
  }
}
